import dayjs from "dayjs";

export type ActivityObject = {
    id: string | number;
    title: string;
    msg: string;
    createDate: string;
};

export const demoActivities: ActivityObject[] = [
    {
        id: 1,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 2,
        title: "Blocked Users",
        msg: "Admin Blocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 3,
        title: "Delete ReportPost",
        msg: "Admin Delete ReportPost",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 4,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 5,
        title: "Send Notification",
        msg: "Admin Send Notification for Multiple Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 6,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 7,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 8,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 9,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 10,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    },
    {
        id: 11,
        title: "Unblocked Users",
        msg: "Admin Unblocked Users",
        createDate: dayjs(new Date(2024, 6, 30, 10, 30, 0)).toString()
    }
];
